/**
 * WCAG / ARIA name-from-prohibited remediation.
 *
 * This intentionally makes only semantic DOM changes. It does not alter CSS,
 * video playback settings, product data, or existing click handlers.
 */
(function () {
  'use strict';

  var LABEL_ATTRIBUTES = ['aria-label', 'aria-labelledby', 'aria-braillelabel'];
  var observedRoots = new WeakSet();

  function removeProhibitedNames(element) {
    LABEL_ATTRIBUTES.forEach(function (attribute) {
      element.removeAttribute(attribute);
    });
  }

  function remediateVideo(video) {
    if (video.dataset.ariaNameRemediated === 'true') return;

    var description = video.getAttribute('aria-label');
    removeProhibitedNames(video);

    if (video.controls && description) {
      var adjacentDescription = document.createElement('span');
      adjacentDescription.className = 'sr-only';
      adjacentDescription.dataset.videoDescription = 'true';
      adjacentDescription.textContent = description;
      video.insertAdjacentElement('afterend', adjacentDescription);
    } else if (!video.controls) {
      // Autoplay/background videos have equivalent nearby page content and are decorative.
      video.setAttribute('aria-hidden', 'true');
    }

    video.dataset.ariaNameRemediated = 'true';
  }

  function remediateThirdPartyStatus(indicator) {
    // The unread-replies dot conveys status; it is not a decorative span.
    // A status role permits the existing accessible name without changing UI behavior.
    if (!indicator.hasAttribute('role')) indicator.setAttribute('role', 'status');
  }

  function remediateDecorativeSpan(span) {
    removeProhibitedNames(span);
  }

  function remediateThirdPartyHiddenStatus(element) {
    // WCAG / ARIA 整改：原生 hidden 已隐藏该第三方客户状态，不再重复声明 aria-hidden。
    element.removeAttribute('aria-hidden');
  }

  function remediate(root) {
    var scope = root && root.querySelectorAll ? root : document;

    if (root && root.matches && root.matches('video[aria-label], video[aria-labelledby], video[aria-braillelabel]')) {
      remediateVideo(root);
    }
    scope.querySelectorAll('video[aria-label], video[aria-labelledby], video[aria-braillelabel]').forEach(remediateVideo);

    if (root && root.matches && root.matches('span.activator__indicator[aria-label="Unread replies"]')) {
      remediateThirdPartyStatus(root);
    }
    scope.querySelectorAll('span.activator__indicator[aria-label="Unread replies"]').forEach(remediateThirdPartyStatus);

    if (root && root.matches && root.matches('span[aria-hidden="true"][aria-label], span[aria-hidden="true"][aria-labelledby], span[aria-hidden="true"][aria-braillelabel]')) {
      remediateDecorativeSpan(root);
    }
    scope
      .querySelectorAll('span[aria-hidden="true"][aria-label], span[aria-hidden="true"][aria-labelledby], span[aria-hidden="true"][aria-braillelabel]')
      .forEach(remediateDecorativeSpan);

    if (root && root.matches && root.matches('[class*="panel__customer-"][hidden][aria-hidden]')) {
      remediateThirdPartyHiddenStatus(root);
    }
    scope
      .querySelectorAll('[class*="panel__customer-"][hidden][aria-hidden]')
      .forEach(remediateThirdPartyHiddenStatus);
  }

  function observeRoot(root) {
    if (!root || observedRoots.has(root)) return;
    observedRoots.add(root);

    remediate(root);

    if (root.querySelectorAll) {
      root.querySelectorAll('*').forEach(function (element) {
        if (element.shadowRoot) observeRoot(element.shadowRoot);
      });
    }

    if (typeof MutationObserver === 'undefined') return;

    new MutationObserver(function (records) {
      records.forEach(function (record) {
        if (record.type === 'attributes') remediate(record.target);

        record.addedNodes.forEach(function (node) {
          if (node.nodeType !== Node.ELEMENT_NODE) return;

          remediate(node);
          if (node.shadowRoot) observeRoot(node.shadowRoot);

          node.querySelectorAll('*').forEach(function (element) {
            if (element.shadowRoot) observeRoot(element.shadowRoot);
          });
        });
      });
    }).observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-label', 'aria-labelledby', 'aria-braillelabel', 'aria-hidden', 'hidden']
    });
  }

  function start() {
    if (Element.prototype.attachShadow && !Element.prototype.attachShadow.__ariaNameRemediationWrapped) {
      var originalAttachShadow = Element.prototype.attachShadow;
      var wrappedAttachShadow = function () {
        var shadowRoot = originalAttachShadow.apply(this, arguments);
        observeRoot(shadowRoot);
        return shadowRoot;
      };

      wrappedAttachShadow.__ariaNameRemediationWrapped = true;
      Element.prototype.attachShadow = wrappedAttachShadow;
    }

    observeRoot(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
